import * as React from 'react';
import antd from 'antd';
import styled from 'styled-components';
import { ColSize } from 'antd/lib/col';

declare type ColSpanType = ColSize;

export const PageColLayout: { [key: string]: ColSpanType } = {
    xl: {
        span: 12,
        offset: 0,
    },
    lg: {
        span: 14,
        offset: 0,
    },
    md: {
        span: 16,
        offset: 0,
    },
    sm: {
        span: 22,
        offset: 1,
    },
    xs: {
        span: 22,
        offset: 1,
    },
};
;


